import {
  ArrowLeftRight,
  Banknote,
  Car,
  CircleDollarSign,
  Clapperboard,
  CreditCard,
  HeartPulse,
  Lightbulb,
  Plane,
  Receipt,
  ShoppingBag,
  ShoppingCart,
  Utensils,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { TransactionCategory } from '@/types'

export const transactionCategoryLabels: Record<TransactionCategory, string> = {
  GROCERIES: 'Groceries',
  DINING: 'Dining',
  SHOPPING: 'Shopping',
  HEALTHCARE: 'Healthcare',
  UTILITIES: 'Utilities',
  TRANSPORTATION: 'Transportation',
  ENTERTAINMENT: 'Entertainment',
  TRAVEL: 'Travel',
  TRANSFER: 'Transfer',
  PAYMENT: 'Payment',
  ATM: 'ATM',
  INCOME: 'Income',
  OTHER: 'Other',
}

// Hearth financial-category chips — a fixed palette so a category reads the
// same everywhere (transaction lists, "Worth a look", spending chart).
export const transactionCategoryChips: Record<
  TransactionCategory,
  { icon: LucideIcon; chipClass: string }
> = {
  GROCERIES: { icon: ShoppingCart, chipClass: 'bg-success-500/10 text-success-500' },
  DINING: { icon: Utensils, chipClass: 'bg-[#d98142]/10 text-[#d98142]' },
  SHOPPING: { icon: ShoppingBag, chipClass: 'bg-[#b96a8c]/10 text-[#b96a8c]' },
  HEALTHCARE: { icon: HeartPulse, chipClass: 'bg-error-500/10 text-error-500' },
  UTILITIES: { icon: Lightbulb, chipClass: 'bg-info-500/10 text-info-500' },
  TRANSPORTATION: { icon: Car, chipClass: 'bg-info-500/10 text-info-500' },
  ENTERTAINMENT: { icon: Clapperboard, chipClass: 'bg-[#7c6fa8]/10 text-[#7c6fa8]' },
  TRAVEL: { icon: Plane, chipClass: 'bg-info-500/10 text-info-500' },
  TRANSFER: { icon: ArrowLeftRight, chipClass: 'bg-info-500/10 text-info-500' },
  PAYMENT: { icon: Receipt, chipClass: 'bg-info-500/10 text-info-500' },
  ATM: { icon: CreditCard, chipClass: 'bg-info-500/10 text-info-500' },
  INCOME: { icon: Banknote, chipClass: 'bg-success-500/10 text-success-500' },
  OTHER: { icon: CircleDollarSign, chipClass: 'bg-info-500/10 text-info-500' },
}

export function formatTransactionAmount(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(Math.abs(amount))
}
